<template>
  <a-card title="资金提现" :bordered="false" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row>
      <a-col :span="12">
        <a-form @submit="handleSubmit" :form="form">
          <a-form-item label="账户余额" v-bind="formItemLayout">
            <span>{{ withdrawInfo.accountTotal }}</span>
          </a-form-item>
          <a-form-item label="提现金额" v-bind="formItemLayout"><span>{{ withdrawInfo.accountAbleDrawCash }}</span>（提现冻结金额：{{
              withdrawInfo.accountFreeze
            }}元)
          </a-form-item>
          <a-form-item label="提现金额" v-bind="formItemLayout">
            <a-input placeholder="每笔需50或以上" style="max-width:200px;"
                     oninput="if(value<50)'111'"
                     v-decorator="['withdrawFee', { rules: [
              { required: true, message: '请输入提现金额' },
              {
                pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/,
                message: '请输入正确的提现金额',
                trigger: 'blur'},
                {validator:this.checkWithdrawFee}
              ]}]"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayoutBtn">
            <a-button type="primary" htmlType="submit">确认提现</a-button>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :span="12">
        <h3 style="margin-left:10px;">当前提现账户</h3>
        <div>
          <div class="tr">
            <div class="left-style">账户名:</div>
            {{ withdrawInfo.myBanKName }}
          </div>
          <div class="tr">
            <div class="left-style">银行账号:</div>
            {{ withdrawInfo.myBankCardNo }}
          </div>
          <div class="tr">
            <div class="left-style">开户银行:</div>
            {{ withdrawInfo.myBanKBranch }}
          </div>
        </div>
        <!-- <detail-list :col="1" title="当前提现账户">
          <detail-list-item term="账户名">{{withdrawInfo.myBanKName}}</detail-list-item>
          <detail-list-item term="银行账号">{{withdrawInfo.myBankCardNo}}</detail-list-item>
          <detail-list-item term="开户银行">{{withdrawInfo.myBanKBranch}}</detail-list-item>
        </detail-list> -->
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import formMixins from '../../../utils/mixins/formMixins'

export default {
  name: 'ExtractMoney',
  mixins: [formMixins],
  data() {
    return {
      withdrawInfo: {
        accountTotal: 0,
        accountAbleDrawCash: 0,
        accountFreeze: 0
      },
      preventReSubmit: '',
      formItemLayoutBtn: {
        wrapperCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 4 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 5 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 4 },
          lg: { span: 5 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 20 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  mounted() {
    this.getMerchantFinanceInfo()
    this.getPreventResubmitKey()
  },
  methods: {
    //金额输入框验证
    checkWithdrawFee(rule, value, callback) {
      setTimeout(() => {
        if (Number(value) > Number(this.form.validateFields.accountAbleDrawCash)) {
          callback(new Error('提现金额必须要小于或等于可提现金额'))
        } else if (Number(value) < 50) {
          callback(new Error('提现金额必须大于50元'))
        } else {
          callback()
        }
      }, 1000)
    },
    //获取商户信息
    getMerchantFinanceInfo() {
      this.getHttpServices().getOrderService().get('money/getMerchantWithdrawList')
        .then(res => {
          this.withdrawInfo = res
          this.getLogUtils().logWithTag('withdrawInfo', res)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    //获取防重复码
    getPreventResubmitKey() {
      this.getHttpServices().getBaseService().get('preventResubmit/getPreventResubmitKey')
        .then(res => {
          this.getLogUtils().logWithTag('getPreventResubmitKey===============', res)
        }).catch(reason => {
        this.preventReSubmit = reason
        this.getLogUtils().logWithTag('getPreventResubmitKey===============', reason)
      })
    },
    //提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.getHttpServices().getOrderService().post('money/merchantWithdraw/', {
            withdrawFee: values.withdrawFee,
            preventReSubmit: this.preventReSubmit
          })
            .then(res => {
              this.getLogUtils().logWithTag('================', res)
              this.$message.success('提现成功')
            }).catch(reason => {
            this.$message.error('提现失败')
            this.showNetWorkErrorMessage(reason)
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.tr {
  font-size: 14px;
  display: flex;
  margin: 20px 0;
}

.left-style {
  width: 70px;
  margin-right: 20px;
  text-align: right;
}

.right-style {
  text-align: left;
  width: 30%;
}
</style>